{
  "airtable": {
    "title": "Airtable",
    "hex": "18BFFF"
  },
  "anthropic": {
    "title": "Anthropic",
    "hex": "191919"
  },
  "claude": {
    "title": "Claude",
    "hex": "D97757"
  },
  "crewai": {
    "title": "CrewAI",
    "hex": "FF5A50"
  },
  "css": {
    "title": "CSS",
    "hex": "663399"
  },
  "cursor": {
    "title": "Cursor",
    "hex": "000000"
  },
  "davinciresolve": {
    "title": "DaVinci Resolve",
    "hex": "233A51"
  },
  "docker": {
    "title": "Docker",
    "hex": "2496ED"
  },
  "elevenlabs": {
    "title": "ElevenLabs",
    "hex": "000000"
  },
  "expo": {
    "title": "Expo",
    "hex": "1C2024"
  },
  "express": {
    "title": "Express",
    "hex": "0A0A0A"
  },
  "fastapi": {
    "title": "FastAPI",
    "hex": "009688"
  },
  "figma": {
    "title": "Figma",
    "hex": "F24E1E"
  },
  "firebase": {
    "title": "Firebase",
    "hex": "DD2C00"
  },
  "framer": {
    "title": "Framer",
    "hex": "0055FF"
  },
  "git": {
    "title": "Git",
    "hex": "F03C2E"
  },
  "github": {
    "title": "GitHub",
    "hex": "181717"
  },
  "githubactions": {
    "title": "GitHub Actions",
    "hex": "2088FF"
  },
  "gmail": {
    "title": "Gmail",
    "hex": "EA4335"
  },
  "google": {
    "title": "Google",
    "hex": "4285F4"
  },
  "googleads": {
    "title": "Google Ads",
    "hex": "4285F4"
  },
  "googleanalytics": {
    "title": "Google Analytics",
    "hex": "E37400"
  },
  "googlechrome": {
    "title": "Google Chrome",
    "hex": "4285F4"
  },
  "googledocs": {
    "title": "Google Docs",
    "hex": "4285F4"
  },
  "googledrive": {
    "title": "Google Drive",
    "hex": "4285F4"
  },
  "googlegemini": {
    "title": "Google Gemini",
    "hex": "8E75B2"
  },
  "googlesearchconsole": {
    "title": "Google Search Console",
    "hex": "458CF5"
  },
  "googlesheets": {
    "title": "Google Sheets",
    "hex": "34A853"
  },
  "googleslides": {
    "title": "Google Slides",
    "hex": "FBBC04"
  },
  "hetzner": {
    "title": "Hetzner",
    "hex": "D50C2D"
  },
  "html5": {
    "title": "HTML5",
    "hex": "E34F26"
  },
  "huggingface": {
    "title": "Hugging Face",
    "hex": "FFD21E"
  },
  "javascript": {
    "title": "JavaScript",
    "hex": "F7DF1E"
  },
  "langchain": {
    "title": "LangChain",
    "hex": "7FC8FF"
  },
  "langgraph": {
    "title": "LangGraph",
    "hex": "7FC8FF"
  },
  "mailchimp": {
    "title": "MailChimp",
    "hex": "FFE01B"
  },
  "make": {
    "title": "Make",
    "hex": "6D00CC"
  },
  "meta": {
    "title": "Meta",
    "hex": "0467DF"
  },
  "modelcontextprotocol": {
    "title": "Model Context Protocol",
    "hex": "000000"
  },
  "mongodb": {
    "title": "MongoDB",
    "hex": "47A248"
  },
  "mongoose": {
    "title": "Mongoose",
    "hex": "880000"
  },
  "n8n": {
    "title": "n8n",
    "hex": "EA4B71"
  },
  "nextdotjs": {
    "title": "Next.js",
    "hex": "000000"
  },
  "nodedotjs": {
    "title": "Node.js",
    "hex": "5FA04E"
  },
  "perplexity": {
    "title": "Perplexity",
    "hex": "1FB8CD"
  },
  "postgresql": {
    "title": "PostgreSQL",
    "hex": "4169E1"
  },
  "prisma": {
    "title": "Prisma",
    "hex": "2D3748"
  },
  "python": {
    "title": "Python",
    "hex": "3776AB"
  },
  "react": {
    "title": "React",
    "hex": "61DAFB"
  },
  "removedotbg": {
    "title": "remove.bg",
    "hex": "54616C"
  },
  "revenuecat": {
    "title": "RevenueCat",
    "hex": "F2545B"
  },
  "semrush": {
    "title": "Semrush",
    "hex": "FF642D"
  },
  "stripe": {
    "title": "Stripe",
    "hex": "635BFF"
  },
  "supabase": {
    "title": "Supabase",
    "hex": "3FCF8E"
  },
  "tailwindcss": {
    "title": "Tailwind CSS",
    "hex": "06B6D4"
  },
  "telegram": {
    "title": "Telegram",
    "hex": "26A5E4"
  },
  "testinglibrary": {
    "title": "Testing Library",
    "hex": "E33332"
  },
  "typescript": {
    "title": "TypeScript",
    "hex": "3178C6"
  },
  "v0": {
    "title": "v0",
    "hex": "000000"
  },
  "vercel": {
    "title": "Vercel",
    "hex": "000000"
  },
  "vite": {
    "title": "Vite",
    "hex": "9135FF"
  },
  "vitest": {
    "title": "Vitest",
    "hex": "00FF74"
  },
  "whatsapp": {
    "title": "WhatsApp",
    "hex": "25D366"
  },
  "wordpress": {
    "title": "WordPress",
    "hex": "21759B"
  },
  "x": {
    "title": "X",
    "hex": "000000"
  },
  "youtube": {
    "title": "YouTube",
    "hex": "FF0000"
  },
  "zapier": {
    "title": "Zapier",
    "hex": "FF4F00"
  },
  "zod": {
    "title": "Zod",
    "hex": "408AFF"
  }
}
